import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Modal, TextInput } from "risa-oasis-ui_v2";
import { getFileDownloadUrl } from "../../../api/firebase/firestoreService";
import { DocumentViewerTitleMap } from "../../../constants/statusToDocMap/statusToDocMap";
import { ScreenNamesForBigQuery } from "../../../enums/eventsData";
import { ModalId } from "../../../enums/modalId";
import { RootState } from "../../../redux/store/store";
import { getOrgIdForFetchExternalWorklist } from "../../../utils/organizationHelper";
import { getViewDocumentEventNameWithFallback } from "../../../utils/viewDocumnetEventTypeName";
import { apiWorkerManager } from "../../../workerManagers/workerManager";
import PdfRender from "../../pdfRender/pdfRender";

interface DocViewerModalwithTitleProps {
  title?: string;
  fileUrl?: string;
  onClose: () => void;
}

const DocViewerModalwithTitle = (props: DocViewerModalwithTitleProps) => {
  const [pdfPath, setPdfPath] = useState<string>("");
  const [, setIsLoading] = useState<boolean>(false);
  const { metaData } = useSelector((state: RootState) => state.modal);
  const { singleMedicalPaOrder } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );
  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );
  const orgID = getOrgIdForFetchExternalWorklist();

  const title = DocumentViewerTitleMap[metaData?.docData?.doc_type ?? ""];

  const isEventLogged = useRef(false);

  useEffect(() => {}, []);

  const fetchPdfUrl = async () => {
    if (!metaData?.docData?.doc_path) return;

    setIsLoading(true);
    try {
      const downloadUrl = await getFileDownloadUrl(metaData.docData.doc_path);
      if (downloadUrl) {
        setPdfPath(downloadUrl);
        !isEventLogged.current &&
          apiWorkerManager.enqueueAndProcess({
            patient_id: singleMedicalPaOrder?.patient_id ?? "",
            user_id: user?.id ?? "",
            user_email: user?.email ?? "",
            order_id: singleMedicalPaOrder?.order_id ?? "",
            org_id: orgID ?? "",
            event_name: getViewDocumentEventNameWithFallback(
              metaData?.docData?.doc_type ?? "",
            ),
            additional_data: {
              screen_name: ScreenNamesForBigQuery.DOCUMENTS_SCREEN,
              doc_type: metaData?.docData?.doc_type ?? "",
              doc_title: metaData?.docData?.doc_title ?? "",
              doc_path: metaData?.docData?.doc_path ?? "",
            },
          });
        isEventLogged.current = true;
      }
    } catch (error) {
      console.error("Error fetching PDF URL:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = async () => {
    if (!pdfPath) return;

    try {
      const response = await fetch(pdfPath);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = metaData?.docData?.doc_title || "document.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  useEffect(() => {
    fetchPdfUrl();
  }, [metaData]);

  return (
    <Modal
      dialogId={ModalId.DOC_VIEWER_MODAL_WITH_TITLE}
      onSave={() => {}}
      title={title}
      saveButtonText={"Save"}
      cancelText={"Cancel"}
      heightPercentage={70}
      onCancel={() => {
        props.onClose();
      }}
      onClose={() => {
        props.onClose();
      }}
    >
      <div className="doc-viewer-modal--container flex h-full flex-col gap-3 overflow-y-hidden">
        <div className="doc-viewer-modal--title">
          <TextInput
            id="title"
            label="Documnet Title (Enter as per OncoEmr)"
            onChange={(e) => {}}
            defaultValue={metaData?.docData?.doc_title ?? ""}
          />
        </div>
        <div
          className="text mr-1 flex cursor-pointer flex-row items-center justify-end text-sm font-bold text-tertiaryBlue-4 hover:text-tertiaryBlue-5"
          onClick={handleDownload}
        >
          Download
        </div>
        <div className="h-full overflow-y-scroll">
          <PdfRender
            file={pdfPath}
            hideRotateButtons={true}
            hideZoomButtons={true}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DocViewerModalwithTitle;
